import React from 'react';
import type {
  ComposeFormState,
  EmailSignature,
  MarketingEmailTemplate,
  SignatureImage,
} from '../../../models/MasterAdmin/marketingEmail';
import ComposePanel from './ComposePanel';
import { meModalOverlayClass } from './marketingEmailUi';

interface ComposeModalProps {
  open: boolean;
  form: ComposeFormState;
  templates: MarketingEmailTemplate[];
  signatures: EmailSignature[];
  signatureImages?: SignatureImage[];
  fromEmails?: string[];
  contactSuggestions?: string[];
  onChange: (patch: Partial<ComposeFormState>) => void;
  onSend: () => void;
  onSchedule: () => void;
  onSaveDraft: () => void;
  onDiscard: () => void;
  onDelete?: () => void;
  editingId?: string | null;
  onClose: () => void;
  onManageSignatures: () => void;
  onCreateTemplate: () => void;
  sending?: boolean;
  editorKey?: string | number;
}

const ComposeModal: React.FC<ComposeModalProps> = ({
  open,
  ...panelProps
}) => {
  if (!open) return null;

  return (
    <div className={meModalOverlayClass}>
      <div className="flex h-[min(92vh,900px)] w-full max-w-5xl flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl dark:border-gray-700 dark:bg-gray-900">
        <ComposePanel {...panelProps} modal />
      </div>
    </div>
  );
};

export default ComposeModal;
